import Apollo from '@adoratorio/apollo';
import engine from './engine';
import {
  angleBetween,
  radTodeg,
  distanceBetween,
  norm,
} from './utils';

const cursor = {
  ref: null,

  init(DOMEelement) {
    this.ref = new Apollo({
      cursor: DOMEelement,
      easing: {
        mode: Apollo.EASING.CUBIC,
        duration: 400,
      },
      props: [{
        key: 'r',
        type: Apollo.PROPERTY_TYPE.ATTRIBUTE,
        target: DOMEelement.querySelector('svg circle'),
        suffix: Apollo.PROPERTY_SUFFIX.NO_SUFFIX,
        easing: {
          mode: Apollo.EASING.CUBIC,
          duration: 400,
        },
        initial: parseFloat(DOMEelement.querySelector('svg circle').getAttribute('r')),
      }, {
        key: 'opacity',
        type: Apollo.PROPERTY_TYPE.STYLE,
        target: DOMEelement,
        suffix: Apollo.PROPERTY_SUFFIX.NO_SUFFIX,
        easing: {
          mode: Apollo.EASING.CUBIC,
          duration: 400,
        },
        initial: 1,
      }, {
        key: 'scaleX',
        type: Apollo.PROPERTY_TYPE.TRANSFORM,
        target: document.querySelector('.cursor-motion'),
        suffix: Apollo.PROPERTY_SUFFIX.NO_SUFFIX,
        easing: {
          mode: Apollo.EASING.CUBIC,
          duration: 400,
        },
        initial: 1,
        precision: 4,
      }, {
        key: 'scaleY',
        type: Apollo.PROPERTY_TYPE.TRANSFORM,
        target: document.querySelector('.cursor-motion'),
        suffix: Apollo.PROPERTY_SUFFIX.NO_SUFFIX,
        easing: {
          mode: Apollo.EASING.CUBIC,
          duration: 400,
        },
        initial: 1,
        precision: 4,
      }, {
        key: 'rotate',
        type: Apollo.PROPERTY_TYPE.TRANSFORM,
        target: document.querySelector('.cursor-motion'),
        suffix: Apollo.PROPERTY_SUFFIX.DEG,
        easing: {
          mode: Apollo.EASING.CUBIC,
          duration: 100,
        },
        initial: 0,
        precision: 4,
      }],
      targets: [{
        id: 'hover',
        elements: Array.from(document.querySelectorAll('[data-apollo-hover]')),
        offset: { x: 0, y: 0 },
      }],
      aion: engine,
    });
    // engine.add(cursor.motion, 'cursor-motion');
  },

  readd(id, element) {
    cursor.ref.addTarget({
      id,
      elements: Array.from(element.querySelectorAll('[data-apollo-hover]')),
      offset: { x: 0, y: 0 },
    });
  },

  remove(id) {
    cursor.ref.removeTarget(id);
  },

  motion() {
    const distance = Math.abs(distanceBetween(cursor.ref.mouse, cursor.ref.coords));
    const scale = norm(distance, Math.max(window.innerWidth, window.innerHeight), 100);
    const angle = angleBetween(cursor.ref.coords, cursor.ref.mouse);
    cursor.ref.getProperty('scaleX').value = 1 + (scale * 2);
    cursor.ref.getProperty('scaleY').value = 1 - (scale * 2);
    cursor.ref.getProperty('rotate').value = radTodeg(angle);
  },
};

export default cursor;
